/* 
PROPS
size: determine height of the spinning wheel and its container by providing a string in css format (examples: "9px", "13vh", "2em" etc)
*/

import React from 'react'
import styles from './Loading.module.css';

const Loading = (props) => {
  return (
    <div style={props.size ? {height: props.size} : {}}  className={`${props.className} ${styles.container} spinnerContainer`}>
      <div 
      style={props.size ? {height: props.size, width: props.size} : {}} 
      className="spinner-border text-primary " role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default Loading;
